/**
 * Used to defined display Mode and the css class
 */
export enum TableDisplayMode {
    DEFAULT_BROWSER = 'table-default-browser',
    FLEX_MODE = 'table-flex-mode'
}
